import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useWeather } from '../../context';
import { supabase } from '../../lib/supabase';
import { Save } from 'lucide-react';

export function SaveSearchButton() {
  const { user } = useAuth();
  const { 
    modelSelect, 
    parameterSelect, 
    startDate, 
    endDate, 
    drawInstance,
    resolution 
  } = useWeather();
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [error, setError] = useState('');

  if (!user) return null;

  const handleSave = async () => {
    if (!searchName.trim()) {
      setError('Please enter a name for your search');
      return;
    }

    try {
      const polygon = drawInstance?.getAll();
      if (!polygon) {
        setError('No area selected');
        return;
      }

      const { error: saveError } = await supabase
        .from('saved_searches')
        .insert({
          name: searchName,
          model: modelSelect,
          parameter: parameterSelect,
          start_date: startDate,
          end_date: endDate,
          polygon,
          resolution,
          user_id: user.id
        });

      if (saveError) throw saveError;

      setShowSaveDialog(false);
      setSearchName('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save search');
    }
  };

  return (
    <>
      <button
        onClick={() => setShowSaveDialog(true)}
        className="btn w-full flex items-center justify-center gap-2"
      >
        <Save className="w-4 h-4" />
        Save Search
      </button>

      {showSaveDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="glass-panel p-6 w-96">
            <h3 className="text-lg font-bold mb-4">Save Search</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
                  Search Name
                </label>
                <input
                  type="text"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  className="input w-full"
                  placeholder="Enter a name for your search"
                />
              </div>

              {error && (
                <div className="text-[var(--danger-color)] text-sm">
                  {error}
                </div>
              )}

              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowSaveDialog(false)}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="btn"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}